<template>
    <div class="col-12 col-lg-4 dashboard__box-col">
        <div class="box box--darker-blue">
            <h2 class="h h--2">Promocje specjalne</h2>
            <p>To miejsce, w którym znajdziesz wszystkie najnowsze promocje specjalne - bądź na bieżąco!</p>
            <router-link :to="{name: 'SpecialActionsList'}" class="button button__bottom">Zobacz listę &raquo;</router-link>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SpecialActionsWidget',
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/specialActions/SpecialActionsWidget.vue